import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const anyOtherCognitiveImpairment: AnswerPathTreeNode = {
  path: 'anyOtherCognitiveImpairment',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredAnyOtherCognitiveImpairmentDetails }],
};
